import { green, orange, red, yellow } from '@ant-design/colors'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Tag, theme, Tooltip } from 'antd'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { Event as EventModel } from '../../models/Event'
import { useAppSelector } from '../../store/hooks'
import { selectEventById } from '../../store/membership/EventReducer'

type Props = SBModelComponent<EventModel> & { wrap?: boolean }

const Cell: FC<Props> = ({ id, model, wrap = false }) => {
  const { token } = theme.useToken()

  const item = model ? model : useAppSelector(selectEventById(id!))

  const getFillRateColor = (event: EventModel) => {
    if (event.fillRate < 50) return red[1]
    if (event.fillRate < 70) return yellow[1]
    return green[1]
  }

  const getBorderColorStyle = (event: EventModel) => {
    if (event.isPublished === false) return orange[2]
    if (event.fillRate < 50) return red[2]
    if (event.fillRate < 70) return yellow[2]
    return green[2]
  }

  const getBorderStyle = (event: EventModel): React.CSSProperties => {
    const color = getBorderColorStyle(event)
    return {
      borderColor: color,
      borderWidth: '1px',
      borderStyle: event.isPublished ? 'solid' : 'dashed',
    }
  }

  const getTootltipLabel = (event: EventModel) => {
    return event.isPublished
      ? `${Math.round(event.fillRate)}% booked`
      : 'Unpublished'
  }

  if (!item) {
    return <></>
  }

  return (
    <Link
      title={item.en.title}
      to={`/membership/events/${item.id}/informations`}
    >
      <Tooltip title={getTootltipLabel(item)}>
        <Tag
          key={item.id}
          style={{
            ...getBorderStyle(item),
            width: '100%',
            overflow: wrap ? undefined : 'hidden',
            whiteSpace: wrap ? 'normal' : undefined,
            cursor: 'pointer',
            background: `linear-gradient(90deg, ${getFillRateColor(item)} ${item.fillRate}%, #fefefe ${item.fillRate}%)`,
            color: '#000',
          }}
        >
          {item.en.title}
        </Tag>
      </Tooltip>
    </Link>
  )
}

type CalendarCellType = { CalendarCell: typeof Cell }

export { Cell, type CalendarCellType }
